import React from 'react';
import { selectPropTypes } from '@App/common/components/Select/SelectPropTypes';
import SelectCommon from '@App/common/components/Select/Select';
import FormErrorText from '@Theme/natucare/components/FormErrorText/FormErrorText';
import * as styles from './Select.module.scss';
const Select = props => /*#__PURE__*/React.createElement("div", {
  className: styles.rootWrapper
}, (props === null || props === void 0 ? void 0 : props.label) && (props === null || props === void 0 ? void 0 : props.name) && /*#__PURE__*/React.createElement("label", {
  className: styles.rootLabel,
  htmlFor: props.name
}, props.label), /*#__PURE__*/React.createElement(SelectCommon, Object.assign({}, props, {
  classname: `${styles.root} ${props.error ? styles.rootError : ''}`
})), (props === null || props === void 0 ? void 0 : props.error) && /*#__PURE__*/React.createElement(FormErrorText, {
  text: props.errorMsg
}));
export default Select;